module.exports = __webpack_public_path__ + "static/media/display-suite-06.025d55b0.png";